import { render, staticRenderFns } from "./gaAdminLayout.vue?vue&type=template&id=1079861f&scoped=true"
import script from "./gaAdminLayout.vue?vue&type=script&lang=js"
export * from "./gaAdminLayout.vue?vue&type=script&lang=js"
import style0 from "./gaAdminLayout.vue?vue&type=style&index=0&id=1079861f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079861f",
  null
  
)

export default component.exports